<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">
        {{ this.$store.getters.isCPS ? "Operations Teams" : "Lead Sources" }}
      </h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{
          this.$store.getters.isCPS
            ? "Create New Operations Team"
            : "Create New Lead Source"
        }}</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          :search="search"
          item-key="id"
          class="elevation-1"
          v-bind="pagingOptions"
          mobile-break-point="1264"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hide-view
              @deleteItem="onDeleteItem"
              @editItem="onEditItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <edit-lead-source-dialog
      v-model="editedLeadSource"
      :show="showLeadSourceEditor"
      @close="showLeadSourceEditor = false"
      @input="onSave"
    ></edit-lead-source-dialog>
  </v-container>
</template>

<script>
import { ListMixin } from "../../../../mixins/ListMixin";
import { removeGQLTypename } from "../../../../helpers";
import DefaultListActions from "../../shared/DefaultListActions";
import gql from "graphql-tag";
import EditLeadSourceDialog from "./EditLeadSourceDialog";

const LEAD_SOURCES_QUERY = gql`
  query leadSourcesList($after: String, $filter: LeadSourceFilterType) {
    leadSources(first: 10000, after: $after, filter: $filter) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

const DELETE_MUTATION = gql`
  mutation deleteLeadSource($id: ID!) {
    deleteLeadSource(id: $id) {
      id
    }
  }
`;

const CREATE_MUTATION = gql`
  mutation createLeadSource($input: LeadSourceInput) {
    createLeadSource(input: $input) {
      id
      name
    }
  }
`;

const UPDATE_MUTATION = gql`
  mutation updateLeadSource($input: LeadSourceInput) {
    updateLeadSource(input: $input) {
      id
      name
    }
  }
`;

export default {
  name: "lead-sources-list",

  mixins: [ListMixin],

  components: { DefaultListActions, EditLeadSourceDialog },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
      editedLeadSource: {},
      showLeadSourceEditor: false,
    };
  },

  computed: {
    items() {
      return this.leadSources && this.leadSources.edges
        ? this.leadSources.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      this.editedLeadSource = {
        name: `New ${
          this.$store.getters.isCPS ? "Operations Team" : "Lead Source"
        }`,
      };
      this.showLeadSourceEditor = true;
    },

    onEditItem(item) {
      this.editedLeadSource = { ...item };
      this.showLeadSourceEditor = true;
    },

    async onDeleteItem(payload) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LEAD_SOURCES_QUERY,
            },
          ],
        });
        this.$store.dispatch("showAppSnackbar", {
          msg: "Lead Source deleted",
        });
      } catch (error) {
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },

    async onSave(payload) {
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;

      try {
        const mutationRes = await this.$apollo.mutate({
          mutation: mutation,
          variables: { input: { ...payload } },
          refetchQueries: [
            {
              query: LEAD_SOURCES_QUERY,
            },
          ],
        });
        this.showLeadSourceEditor = false;
        this.$store.dispatch("showAppSnackbar", {
          msg: "Lead Source saved.",
        });
      } catch (error) {
        console.log("error", error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },

  apollo: {
    leadSources: {
      query: LEAD_SOURCES_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/lead-sources/LeadSourcesList.vue